import { createReducer, on } from '@ngrx/store';
import { setPreferenceIndicesCalcs } from './family-indices-table.action';
export const preferenceIndicesCalcs = createReducer([], on(setPreferenceIndicesCalcs, (state, action) => {
    return action.calcs;
}));
